export class EmptyResponseEntity {}
